import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ConnectWorkflowCanvasInteractionsService {
    private readonly nodeFullscreenRequestedSubject = new Subject<string>();

    readonly nodeFullscreenRequested$: Observable<string> = this.nodeFullscreenRequestedSubject.asObservable();

    requestNodeFullscreen(nodeId: string): void {
        const id = String(nodeId || '').trim();
        if (!id) return;
        this.nodeFullscreenRequestedSubject.next(id);
    }
}

